import { t } from '@lingui/macro';
import { SeoType, BrowseSeoType } from 'types/seoType';
import { CONFIG } from 'utils/config';
import { useDynamicBranding } from 'hooks/useDynamicBranding';

export const useStaticSeo = () => {
    const { name, creatorBrand, samplesWithName } = useDynamicBranding();

    const defaultSeo: SeoType = {
        title: t`Samples - Sample Packs, Free Loops and One Shots`,
        description: t`Get the best sample packs, free loops, synths, bass, vocals, drum kits and sound libraries with AI's help. Spark ideas with the best royalty-free sounds.`,
        imageUrl: `${CONFIG.VITE_SAMPLES_WEB_URL}${
            import.meta.env.BASE_URL
        }assets/seo/social-default.jpg`,
    };

    const forYouSeo: SeoType = {
        title: t`Royalty Free Sample Packs, Loops & Sounds`,
        description: t`Get the best sample packs, free loops, synths, bass, vocals, drum kits and sound libraries with AI's help. Spark ideas with the best royalty-free sounds.`,
        imageUrl: `${CONFIG.VITE_SAMPLES_WEB_URL}${
            import.meta.env.BASE_URL
        }assets/seo/social-default.jpg`,
    };

    const genresSeo: SeoType = {
        title: t`Samples for All Genres - Trap, EDM, Hip-Hop and More`,
        description: t`Get the best samples and loops from every genre. From trap to pop, rock to ambient, browse, discover and download samples today.`,
        imageUrl: defaultSeo.imageUrl,
    };

    const instrumentsSeo: SeoType = {
        title: t`Instrument Samples - Drums, Guitar, Keys and More`,
        description: t`Download the best instrument samples and loops from ${samplesWithName}. Get drums, keys, synths and more. Spark your music production today.`,
        imageUrl: defaultSeo.imageUrl,
    };

    const sfsxSeo: SeoType = {
        title: t`Download Royalty Free Sound Effects (SFX) Samples`,
        description: t`Get access to over 200,000 royalty free sound effects (SFX) for your creative project. Browse the ${samplesWithName} library of Sound FX in MP3 and Wav format.`,
        imageUrl: defaultSeo.imageUrl,
    };

    const chartsSeo = {
        title: t`Top Samples Charts - Trending Sounds and Sample Packs`,
        description: t`Listen to the top trending samples in music production with ${samplesWithName} Charts, download the best royalty-free samples and sample packs at ${name}. `,
        imageUrl: defaultSeo.imageUrl,
    };

    const exclusivesSeo: SeoType = {
        title: t`Exclusives - Get the Best Sample Packs`,
        description: t`Discover exclusive samples from top music producers and artists.`,
        imageUrl: defaultSeo.imageUrl,
    };

    const browseSeo: BrowseSeoType = {
        title: t`Sample Finder - Find Samples for Your Tracks`,
        description: t`Find audio samples fast. Browse sounds with filters or start with a sample search. Get the samples you need and spark inspiration.`,
        header: t`Search`,
        byline: t`Search among millions of samples to find the perfect sound for your next track.`,
        imageUrl: defaultSeo.imageUrl,
    };

    const creatorSharedSeo: SeoType = {
        title: t`Check out this loop I made with ${creatorBrand} on ${samplesWithName}`,
        description: t`${creatorBrand} is the new beat making tool for ${samplesWithName}. Hear how up to eight loops from ${name}'s royalty-free sample library sound together in your browser.`,
        imageUrl: `${CONFIG.VITE_SAMPLES_WEB_URL}${
            import.meta.env.BASE_URL
        }assets/seo/creator-beatmaker.png`,
    };

    const creatorSeo: SeoType = {
        title: t`Free Online Beat Maker - Make a Beat`,
        description: t`Make beats online using real samples with ${name} ${creatorBrand}. Hear how up to eight loops from ${name}'s royalty-free sample library sound together in your browser.`,
        imageUrl: `${CONFIG.VITE_SAMPLES_WEB_URL}${
            import.meta.env.BASE_URL
        }assets/seo/creator-beatmaker.png`,
    };

    return {
        default: defaultSeo,
        forYou: forYouSeo,
        genres: genresSeo,
        instruments: instrumentsSeo,
        charts: chartsSeo,
        exclusives: exclusivesSeo,
        browse: browseSeo,
        creatorShared: creatorSharedSeo,
        creator: creatorSeo,
        sfxs: sfsxSeo,
    };
};
